export const AuthorizationTokenKey: string = "admin-authorization-token";